
import DateComponent from '@/components/DateComponent.vue';
import { mainStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { retencaoFinanceiraStore } from '../../../utils/store-accessor';

import { format } from 'date-fns';
import _ from 'lodash';

@Component({
  components: { DateComponent },
})
export default class ListTitulosPagosAposVencimento extends Vue {
  public isLoading = false;
  public recebimento_titulos = [];
  public c014_unidade = 0;
  public tipo_titulo = [];
  public tipo_filial = '';
  public cobranca_colaborador = '';
  public dataFiltro = '';
  public dataInicial = '';
  public dataFinal = '';
  public selected = [];
  public forma_pagamento = [];

  public headerTitulos = [
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'Título',
      sortable: false,
      value: 'documento',
      align: 'left',
    },
    {
      text: 'Data Vencimento',
      sortable: false,
      value: 'vencimento',
      align: 'left',
    },
    {
      text: 'Data Recebimento',
      sortable: false,
      value: 'recebimento',
      align: 'left',
    },
    {
      text: 'Valor Pago',
      sortable: true,
      value: 'valor_pago',
      align: 'left',
    },
    {
      text: 'Tipo Título',
      sortable: true,
      value: 'tipo',
      align: 'center',
    },
    {
      text: 'Tipo Baixa',
      sortable: true,
      value: 'tipo_baixa',
      align: 'left',
    },
    {
      text: 'Filial',
      sortable: true,
      value: 'filial',
      align: 'left',
    },
    {
      text: 'Cobrança',
      sortable: true,
      value: 'tem_cobranca',
      align: 'left',
    },
  ];

  get itemsTipoTitulo() {
    let item = this.recebimento_titulos;
    let array = [];

    item.map((item) => {
      if (!array.includes(item.tipo)) {
        array.push(item.tipo);
      }
    });

    return array;
  }

  get totalValorSelecionado() {
    let contador = 0;
    let valor = 0;

    if (this.selected) {
      this.selected.map((item) => {
        valor += _.toNumber(item.valor_pago);

        contador += 1;
      });
    }
    return [valor, contador];
  }

  get itemsCobranca() {
    let item = this.recebimento_titulos;
    let array = [];

    item.map((item) => {
      if (item.created_by_name.length > 0) {
        if (!array.includes(item.created_by_name)) {
          array.push(item.created_by_name);
        }
      }
    });

    return array;
  }

  get formasPagamento() {
    return [
      {
        id: 1,
        descricao: 'Em Atraso',
      },
      {
        id: 2,
        descricao: 'Na data do vencimento',
      },
      {
        id: 3,
        descricao: 'Antes do vencimento',
      },
    ];
  }

  get allItems() {
    let item = this.recebimento_titulos;

    if (this.c014_unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014_unidade);
    }

    if (this.tipo_filial) {
      item = item.filter((f) => f.filial === this.tipo_filial);
    }

    if (this.dataFiltro) {
      item = item.filter(
        (f) => format(new Date(f.recebimento), 'dd/MM/yyyy') === format(new Date(this.dataFiltro), 'dd/MM/yyyy')
      );
    }

    if (this.dataInicial && this.dataFinal) {
      // Converter as datas iniciais e finais para objetos Date
      var dataInicial = new Date(this.dataInicial);
      var dataFinal = new Date(this.dataFinal);

      // Filtrar o array de itens
      item = item.filter((f) => {
        // Converter a data do item para objeto Date
        var dataRecebimento = new Date(f.recebimento);

        // Comparar as datas dentro do intervalo
        return dataRecebimento >= dataInicial && dataRecebimento <= dataFinal;
      });
    }

    if (this.tipo_titulo.length > 0) {
      item = item.filter((f) => this.tipo_titulo.includes(f.tipo));
    }

    if (this.cobranca_colaborador.length > 0) {
      item = item.filter((f) => this.cobranca_colaborador.includes(f.created_by_name));
    }

    if (this.forma_pagamento.length > 0) {
      const ids = _.map(this.forma_pagamento, (item) => item.id);
      if (ids.length > 0) {
        item = item.filter((f) => ids.includes(f.tipo_pagamento));
        return item;
      }
    } else {
      return item;
    }
  }

  get totalValorPago() {
    let contador = 0;
    let valor = 0;
    if (this.allItems) {
      this.allItems.map((item) => {
        valor += _.toNumber(item.valor_pago);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async mounted() {
    this.isLoading = true;

    await mainStore.userProfile;

    this.recebimento_titulos = await retencaoFinanceiraStore.getTitulosPagosAposVencimento();

    this.isLoading = false;
  }
}
